import { CardHeaderClassKey } from '@material-ui/core';
import { CSSProperties } from '@material-ui/core/styles/withStyles';

export const MuiCardHeader: Record<CardHeaderClassKey, CSSProperties> = {
  root: { alignItems: 'baseline', flexDirection: 'row-reverse' },
  action: { flex: '0.1 0 auto' },
  avatar: {},
  content: {
    '& .MuiCardHeader-title': {
      fontWeight: 500,
    },
  },
  subheader: {},
  title: {},
};
